import MangroveLogo from "../assets/mangroove-logo.svg";
import MangroveBrand from "../assets/mangroove-brand.svg";
import { trackEvent } from "../utils/segment";
import { useState } from "react";
import Loading from "./loading";
import { toast } from "react-toastify";

export function Footer() {
  const [emailAddress, setEmailAddress] = useState("");
  const isOnHomePage = window.location.pathname === "/";
  const [loading, setLoading] = useState(false);

  const isEmailValid = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubscribeUser = () => {
    if (!emailAddress) return toast.error("Please enter an email address");
    if (!isEmailValid(emailAddress))
      return toast.error("Invalid Email Address");
    setLoading(true);
    try {
      setTimeout(() => {
        // save to segment
        trackEvent("Email Subscription", { emailAddress });
        toast.success("Email Subscribed Successfully", {
          align: "center",
          autoClose: 5000,
        });
        setEmailAddress("");
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.log(error);
      setLoading(false);
      toast.error("Email Subscription Failed", {
        align: "center",
        autoClose: 5000,
      });
    }
  };

  return (
    <div className='footer-container'>
      <div className='footer-cards-container'>
        {/* Brand Card */}
        <div className='footer-card brand-card'>
          <div className='card-header'>
            <div
              className='logo-wrapper'
              onClick={() => window.location.href("/")}
            >
              <img src={MangroveLogo} alt='Mangrove Logo' />
            </div>
            <div className='brand-description'>
              <p>
                Bringing you the finest quality canned foods with authentic
                flavors that celebrate our rich culinary heritage.
              </p>
            </div>
          </div>
          <div className='card-footer'>
            <div className='social-links'>
              <a
                href='https://web.facebook.com/profile.php?id=61578690178560'
                target='_blank'
                rel='noopener noreferrer'
                className='social-link'
              >
                <i className='bi bi-facebook'></i>
              </a>
              <a
                href='https://www.instagram.com/mangrove.foods/'
                target='_blank'
                rel='noopener noreferrer'
                className='social-link'
              >
                <i className='bi bi-instagram'></i>
              </a>
              <a
                href='https://x.com/MangroveFoods'
                target='_blank'
                rel='noopener noreferrer'
                className='social-link'
              >
                <i className='bi bi-twitter-x'></i>
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links Card */}
        <div className='footer-card links-card'>
          <div className='card-header'>
            <h4>Quick Links</h4>
          </div>
          <div className='card-content'>
            <ul className='footer-links'>
              <li>
                <a
                  href={isOnHomePage ? "#about-us" : "/#about-us"}
                  onClick={() => trackEvent("Clicked About Us")}
                >
                  <i className='bi bi-info-circle'></i>
                  About Us
                </a>
              </li>
              <li>
                <a
                  href={isOnHomePage ? "#products-range" : "/#products-range"}
                  onClick={() => trackEvent("Clicked Products")}
                >
                  <i className='bi bi-box-seam'></i>
                  Products
                </a>
              </li>
              <li>
                <a href='mailto:media@mangrovefoods.com'>
                  <i className='bi bi-envelope'></i>
                  Contact Us
                </a>
              </li>
              <li>
                <a href='/privacy-terms?page=privacy'>
                  <i className='bi bi-shield-check'></i>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href='/privacy-terms?page=terms'>
                  <i className='bi bi-file-text'></i>
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter Card */}
        <div className='footer-card newsletter-card'>
          <div className='card-header'>
            <h4>Stay Connected</h4>
            <p>Get the latest updates on our products and exclusive offers</p>
          </div>
          <div className='card-content'>
            <div className='newsletter-form'>
              <div className='input-group'>
                <input
                  className='form-control'
                  type='email'
                  placeholder='Enter your email address'
                  value={emailAddress}
                  onChange={({ target: { value } }) => setEmailAddress(value)}
                />
                <button
                  className='subscribe-btn'
                  disabled={loading}
                  onClick={handleSubscribeUser}
                >
                  {loading ? (
                    <Loading />
                  ) : (
                    <i className='bi bi-arrow-right'></i>
                  )}
                </button>
              </div>
              <p className='newsletter-note'>
                Join thousands of satisfied customers who trust Mangrove Foods
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className='footer-bottom'>
        <div className='copyright'>
          <p>
            © MANGROVE FOODS {new Date().getFullYear()} - ALL RIGHTS RESERVED
          </p>
        </div>
        <div className='footer-brand'>
          <img
            src={MangroveBrand}
            alt='Mangrove Brand'
            className='mangrove-brand'
          />
        </div>
      </div>
    </div>
  );
}
